module.exports = __webpack_public_path__ + "9a8633b6ec44600b5eff6a65c310a586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shouhou.png
// module id = 177
// module chunks = 1